





























import { Component, Prop, Vue } from 'vue-property-decorator'
import touchClass from '@/directives/touch-class'
import SuiIcon from '@/components/Icon/index.vue'

const classNamespace = 'sui-button'
const classMap = {
  type: {
    primary: 'primary',
    plain: 'plain',
    'plain-monior': 'plain-monior',
  },
  size: {
    normal: 'normal',
    small: 'small',
    tiny: 'tiny'
  }
}

type ISize = keyof typeof classMap.size
type IType = keyof typeof classMap.type

@Component({
  name: 'SuiButton',
  directives: {
    touchClass
  },
  components: {
    SuiIcon
  }
})
/**
 * @component
 * @description 按钮，提供几种基础样式和尺寸，可自定义图标。
 */
export default class Comp extends Vue {
  static install(vue: any) {
    vue.component((this as any).options.name, Comp)
  }

  /**
   * @prop type
   * @type string
   * @description 按钮类型
   * @options ["primary", "plain", "plain-monior"]
   * @default primary
   */
  @Prop({
    type: String,
    default: 'primary',
    validator(value: IType) {
      return !!classMap.type[value]
    }
  })
  type!: IType

  /**
   * @prop size
   * @type string
   * @description 大小
   * @options ["normal", "small", "tiny"]
   * @default normal
   */
  @Prop({
    type: String,
    default: 'normal',
    validator(value: ISize) {
      return !!classMap.size[value]
    }
  })
  size!: ISize

  /**
   * @prop disabled
   * @type boolean
   * @description 是否禁用
   * @default false
   */
  @Prop({
    type: Boolean,
    default: false
  })
  disabled!: boolean

  /**
   * @prop loading
   * @type boolean
   * @description 是否展示加载icon
   * @default false
   */
  @Prop({
    type: Boolean,
    default: false
  })
  loading!: boolean

  /**
   * @prop invalid
   * @type boolean
   * @description 是否无效
   * @default false
   */
  @Prop({
    type: Boolean,
    default: false
  })
  invalid!: boolean

  /**
   * @prop fixed
   * @type boolean
   * @description 按钮是否固定在底下方
   * @default false
   */
  @Prop({
    type: Boolean,
    default: false
  })
  fixed!: boolean

  /**
   * @prop radius
   * @type boolean
   * @description 是否为椭圆形按钮
   * @default false
   */
  @Prop({
    type: Boolean,
    default: false
  })
  radius!: boolean

  get fixedClass() {
    return this.fixed ? classNamespace + '--fixed' : ''
  }

  get typeClass() {
    return classNamespace + '--' + classMap.type[this.type]
  }

  get sizeClass() {
    return classNamespace + '--' + classMap.size[this.size]
  }

  get disabledClass() {
    return this.disabled ? classNamespace + '--disabled' : ''
  }

  get invalidClass() {
    return this.invalid ? classNamespace + '--invalid' : ''
  }

  get radiusClass() {
    return this.radius ? classNamespace + '--radius' : ''
  }

  /**
   * @emit click
   * @description 点击触发
   */
  onClick() {
    this.$emit('click')
  }
}

/**
* @slot title
* @description 多行标题
*/
/**
* @slot support
* @description 多行辅助文字
*/
/**
* @slot default
* @description 按钮文案
*/

